<template>
  <div class="leading-6 pt-1.5">
    <!-- Hidden select for Rails form submission -->
    <select :name="name" :id="id" v-model="ratingValue" style="display: none;">
      <option value="">No rating</option>
      <option v-for="n in 5" :key="n" :value="n">
        {{ n }}
      </option>
    </select>

    <!-- PrimeVue Rating Component -->
    <Rating v-model="ratingValue" class="flex space-x-2" />
  </div>
</template>

<script setup>
  import { ref, watch } from 'vue'
  import Rating from 'primevue/rating'

  // Define props
  const props = defineProps({
    name:         { type: String, required: true },
    id:           { type: String, required: true },
    modelValue:   { type: Number, default: null },
    initialValue: { type: Number, default: null }
  })

  // Define emits
  const emit = defineEmits(['update:modelValue'])

  // Local state for rating value
  const ratingValue = ref(props.modelValue || props.initialValue)

  // Watch for external changes to modelValue
  watch(() => props.modelValue, (newValue) => {
    ratingValue.value = newValue
  })

  // Watch for internal changes to ratingValue
  watch(ratingValue, (newValue) => {
    emit('update:modelValue', newValue)
  })
</script>
